export default {
  'login': {
    'welcome': 'Welcome to',
    'platform': 'Smart Maintenance Platform',
    'username': 'Please enter account name',
    'password': 'Please enter password',
    '登录': 'Login',
    'usernameRequired': 'Please enter account name',
    'usernameLength': 'Length between 1 and 10 characters',
    'passwordRequired': 'Please enter password',
    'passwordLength': 'Length between 5 and 15 characters',
    '欢迎使用': 'Welcome to',
    '智慧运维平台': 'Smart Maintenance Platform',
    '请输入账户名称': 'Please enter account name',
    '请输入登录密码': 'Please enter password',
    '请输入登录名称': 'Please enter account name',
    '长度在1到10个字符': 'Length between 1 and 10 characters',
    '长度在5到15个字符': 'Length between 5 and 15 characters',
  },
  'header': {
    'username': 'Username',
    'announcement': 'Announcement',
    'publishTime': 'Publish Time',
    'logout': 'Logout',
    '用户名': 'Username',
    '公告': 'Announcement',
    '发布时间': 'Publish Time',
    '退出': 'Logout',
  },
  'project': {
    'title': 'SmartWaterManagementPlatform' // 添加这一行，英文翻译
  },
  'menu': {
    '项目首页': 'Project Home',
    '账务报表': 'Financial Report',
    '交款退款': 'Payment & Refund',
    '基础资料': 'Basic Info',
    '抄收与设置': 'Meter Reading & Settings',
    '系统管理': 'System Management'
  },
  'submenu': {
    '充值记录': 'Recharge Record',
    '账单流水': 'Bill Flow',
    '售水日报': 'Water Sales Daily',
    '售水月报': 'Water Sales Monthly',
    '售水年报': 'Water Sales Annual',
    '用水类型': 'Water Usage Type',
    '位置信息': 'Location Info',
    '表具类型': 'Meter Type',
    '水表档案': 'Water Meter Archive',
    '阀控策略': 'Valve Control Strategy',
    '账户管理': 'Account Management',
    '全局配置': 'Global Configuration',
    '预警推送': 'Alert Push'
  },
  // 项目首页
  'users': {
    'projectName': 'Project Name',
    'username': 'Username',
    'isAdmin': 'Is Admin',
    'deviceTotal': 'Total Devices',
    'balanceCount': 'Balance Count',
    'totalBalance': 'Total Balance',
    'owingCount': 'Current Owing Count',
    'owingAmount': 'Total Owing Amount',
    'payment': 'Payment & Refund',
    'meterReading': 'Meter Reading & Settings',
    'billFlow': 'Bill Flow',
    '已结算用水量统计': 'Settled Water Usage Statistics',
    'byMonth': 'By Month',
    'byDay': 'By Day',
    '异常告警': 'Abnormal Alarm',
    '用户余额不足告警': 'Low Balance Warning',
    '本月账务统计数据': 'Monthly Financial Statistics',
    'serialNumber': 'No.',
    'meterNumber': 'Meter Number',
    'userName': 'Username',
    'location': 'Location',
    'valveStatus': 'Valve Status',
    'abnormalReason': 'Abnormal Reason',
    'view': 'View',
    'accountingData': 'Monthly Account Statistics',
    'thisMonth': 'This Month',
    'wechatPayment': 'WeChat Payment Amount',
    'businessWater': 'Business Water Sales',
    'discountWater': 'Discount Water Sales',
    'systemTransfer': 'System Transfer Amount',
    'platformRefund': 'Platform Refund Amount',
    'paymentId': 'Payment ID',
    'meterID': 'Meter ID',
    'balance': 'Balance',
    'address': 'Address',
    'yes': 'Yes',
    'no': 'No',
    '是': 'Yes',
    '否': 'No',
    '项目名称': 'Project Name',
    '用户名': 'Username',
    '是否是管理员': 'Is Admin',
    '设备总数量': 'Total Devices',
    '余额数量': 'Balance Count',
    '总剩余额': 'Total Balance',
    '当前欠费数量': 'Current Owing Count',
    '总欠费额': 'Total Owing Amount',
    '交款退款': 'Payment & Refund',
    '抄收与设置': 'Meter Reading & Settings',
    '账单流水': 'Bill Flow',
    '按月': 'By Month',
    '按日': 'By Day',
    '序号': 'No.',
    '表具编号': 'Meter Number',
    '用户名称': 'Username',
    '位置': 'Location',
    '阀门状态': 'Valve Status',
    '异常原因': 'Abnormal Reason',
    '查看': 'View',
    '本月': 'This Month',
    '微信缴费金额': 'WeChat Payment Amount',
    '业务售水金额': 'Business Water Sales',
    '优惠售水金额': 'Discount Water Sales',
    '系统结转金额': 'System Transfer Amount',
    '平台退费金额': 'Platform Refund Amount',
    '缴费编号': 'Payment ID',
    '表号': 'Meter ID',
    '余额': 'Balance',
    '地址': 'Address',
  },
  // 添加到en.js 交款退款
  'accountMent': {
    'projectHome': 'Project Home',
    'paymentRefund': 'Payment & Refund',
    'batchPayment': 'Batch Payment',
    'batchRefund': 'Batch Refund',
    'paymentId': 'Payment ID',
    'meterNumber': 'Meter Number',
    'userName': 'User Name',
    'contactInfo': 'Contact Info',
    'address': 'Address',
    'balance': 'Balance',
    'operation': 'Operation',
    'payment': 'Payment',
    'refund': 'Refund',
    'waterFeePayment': 'Water Fee Payment',
    'waterFeeRefund': 'Water Fee Refund',
    'currentSelection': 'Current Selection',
    'devices': 'devices',
    'selectAllDevices': 'Select all devices in current area',
    'records': 'records',
    'paymentAmount': 'Payment',
    'refundAmount': 'Refund',
    'confirm': 'Confirm',
    'cancel': 'Cancel',
    'note': 'Note',
    'refundableAmount': 'Refundable Amount',
    'refundNote': 'Note: Refund amount = Balance - Other fees',
    'rechargeVoucher': 'Recharge Voucher',
    'orderNumber': 'Order Number',
    'receiptDate': 'Receipt Date',
    'deviceNumber': 'Device Number',
    'currentMeterReading': 'Current Meter Reading',
    'addressInfo': 'Address Info',
    'rechargeAmount': 'Recharge Amount',
    'accountBalance': 'Account Balance',
    'operator': 'Operator',
    'mobileScreenshot': 'You can take a screenshot as a voucher on mobile',
    'print': 'Print',
    'businessWaterSales': 'Business Water Sales',
    'discountWaterSales': 'Discount Water Sales',
    'systemTransfer': 'System Transfer',
    'pleaseEnterAmount': 'Please enter amount',
    '项目首页': 'Project Home',
    '交款退款': 'Payment & Refund',
    '批量缴款': 'Batch Payment',
    '批量退款': 'Batch Refund',
    '缴费编号': 'Payment ID',
    '水表编号': 'Meter Number',
    '用户姓名': 'User Name',
    '联系方式': 'Contact Info',
    '地址': 'Address',
    '余额': 'Balance',
    '操作': 'Operation',
    '缴款': 'Payment',
    '退款': 'Refund',
    '水费交款': 'Water Fee Payment',
    '当前勾选': 'Current Selection',
    '台设备': 'devices',
    '选择当前区域所有设备': 'Select all devices in current area',
    '条': 'records',
    '交款': 'Payment',
    '请输入金额': 'Please enter amount',
    '确定': 'Confirm',
    '备注': 'Note',
    '水费退款': 'Water Fee Refund',
    '可退款金额': 'Refundable Amount',
    '注：退费金额=余额-其它收费金额': 'Note: Refund amount = Balance - Other fees',
    '充值凭证': 'Recharge Voucher',
    '订单编号': 'Order Number',
    '收款日期': 'Receipt Date',
    '设备编号': 'Device Number',
    '当前表码': 'Current Meter Reading',
    '地址信息': 'Address Info',
    '充值金额': 'Recharge Amount',
    '账户余额': 'Account Balance',
    '操作人员': 'Operator',
    '手机可以截个图作为凭证': 'You can take a screenshot as a voucher on mobile',
    '打印': 'Print',
    '取消': 'Cancel',
  },
  // 水表接收与设置的英文翻译
  'waterMeter': {
    'projectHome': 'ProjectHome',
    'waterMeterSetting': 'WaterMeterReception',
    'search': 'PleaseEnterKeywordsToSearch',
    'searchBtn': 'Search',
    'resetBtn': 'Reset',
    'community': 'Community',
    'selectCommunity': 'PleaseSelectCommunity',
    'building': 'Building',
    'selectBuilding': 'PleaseSelectBuilding',
    'unit': 'Unit',
    'selectUnit': 'PleaseSelectUnit',
    'room': 'Room',
    '余额': 'Balance',
    '请选择状态': 'PleaseSelectBalance',
    'selectRoom': 'PleaseSelectRoom',
    'valveControl': 'ValveControl',
    'openValve': 'OpenValve',
    'closeValve': 'CloseValve',
    'alarmCloseValve': 'AlarmCloseValve',
    'valveTest': 'ValveTest',
    'cyclicUploadParam': 'CyclicUploadParam',
    'fixedUploadParam': 'FixedUploadParam',
    'dailyFreezeParam': 'DailyFreezeParam',
    'monthlyFreezeParam': 'MonthlyFreezeParam',
    'dailyFreezeData': 'DailyFreezeData',
    'monthlyFreezeData': 'MonthlyFreezeData',
    'areaExport': 'AreaExport',
    '缴费编号': 'PaymentID',
    '表号': 'MeterID',
    '用户名': 'Username',
    '余额': 'Balance',
    '位置': 'Location',
    '最新上报时间': 'LastReportTime',
    '正向累计流量': 'PositiveFlow',
    '净累计流量': 'NetFlow',
    '反向累计流量': 'NegativeFlow',
    '瞬时流量': 'InstantFlow',
    '电池电压': 'BatteryVoltage',
    '信号强度': 'SignalStrength',
    '上传失败次数': 'UploadFailCount',
    '定时冻结间隔': 'FreezeInterval',
    '压力': 'Pressure',
    '水温': 'WaterTemp',
    '掉电状态': 'PowerDown',
    '低压状态': 'LowPower',
    '阀门状态': 'ValveStatus',
    '磁攻击': 'MagneticAttack',
    '拆卸状态': 'DisassemblyStatus',
    '漏水报警': 'Leakage',
    '反向计量': 'ReverseMetering',
    '流量超限': 'FlowExceed',
    '液位报警': 'liquidLevelAlarm',
    'operation': 'Operation',
    'queryProcessSettings': 'QueryProcessSettings',
    'waterUsageCurve': 'WaterUsageCurve',
    'queryHistoryRecord': 'QueryHistoryRecord',
    'QueryDailyUsage': 'QueryDailyUsage',
    'enterMeterReading': 'EnterMeterReading',
    'noData': 'NoData',
    // 弹窗
    'openValveDevice': 'Open Valve Device',
    'currentSelected': 'Current Selected',
    'devices': 'devices',
    'selectAllDevices': 'Select all devices in current area',
    'records': 'records',
    'submit': 'Submit',
    'cancel': 'Cancel',
    // 查询进程
    'queryProcess': 'Query Process',
    'deviceNumber': 'Device Number',
    'index': 'Index',
    'meterNumber': 'Meter Number',
    'operationContent': 'Operation Content',
    'operationResult': 'Operation Result',
    'createTime': 'Create Time',
    'sendTime': 'Send Time',
    'completeTime': 'Complete Time',
    'responseResult': 'Response Result',
    // 定点上传
    'fixedUpload': 'Fixed Upload',
    'every': 'Every',
    'month': 'Month',
    'day': 'Day',
    'hour': 'Hour',
    'upload': 'Upload',
    'note': 'Note: If not selected, the fixed upload function will be cancelled',
    // 周期上传
    'cyclicUpload': 'Cyclic Upload',
    'uploadTime': 'Upload Time',
    'to': 'to',
    'startTime': 'Start Time',
    'endTime': 'End Time',
    'selectTimeRange': 'Select Time Range',
    'uploadInterval': 'Upload Interval',
    // 冻结数据
    'selectDate': 'Select Date',
    'freezeTime': 'Freeze Time',
    'uploadDate': 'Upload Date',
    'selectMonth': 'Select Month',
    // 冻结参数
    'dailyFreezeTime': 'Daily Freeze Time',
    'selectTime': 'Select Time',
    'monthlyFreezeTime': 'Monthly Freeze Time',
    'of': 'of',
    // 历史记录
    'historyRecord': 'History Record',
    'totalUsage': 'Total Usage',
    'meterReadingTime': 'Meter Reading Time',
    // 用水曲线
    // 录入表码
    'meterReading': 'Meter Reading',
    'save': 'Save',
    '请搜索关键字点击输入进行查询': 'PleaseEnterKeywordsToSearch',
    '查询': 'Search',
    '重选': 'Reset',
    '小区': 'Community',
    '请选择小区': 'PleaseSelectCommunity',
    '楼栋': 'Building',
    '请选择楼栋': 'PleaseSelectBuilding',
    '单元': 'Unit',
    '请选择单元': 'PleaseSelectUnit',
    '房间': 'Room',
    '请选择房间': 'PleaseSelectRoom',
    '项目首页': 'ProjectHome',
    '接收与设置': 'WaterMeterReception',
    '阀门控制': 'ValveControl',
    '开阀': 'OpenValve',
    '关阀': 'CloseValve',
    '报警关阀': 'AlarmCloseValve',
    '阀门测试': 'ValveTest',
    '周期上传参数': 'CyclicUploadParam',
    '定点上传参数': 'FixedUploadParam',
    '日冻结参数': 'DailyFreezeParam',
    '月冻结参数': 'MonthlyFreezeParam',
    '日冻结数据': 'DailyFreezeData',
    '月冻结数据': 'MonthlyFreezeData',
    '区域导出': 'AreaExport',
    '操作': 'Operation',
    '设置进程': 'QueryProcessSettings',
    '用水曲线': 'WaterUsageCurve',
    '历史记录': 'History Record',
    '设备日用量': 'QueryDailyUsage',
    '录入表码': 'EnterMeterReading',
    '开阀设备': 'Open Valve Device',
    '当前勾选': 'Current Selected',
    '台设备': 'devices',
    '选择当前区域所有设备': 'Select all devices in current area',
    '条': 'records',
    '取消': 'Cancel',
    '提交': 'Submit',
    '查询进程': 'Query Process',
    '设备编号': 'Device Number',
    '序号': 'Index',
    '表具编号': 'Meter Number',
    '操作内容': 'Operation Content',
    '操作结果': 'Operation Result',
    '创建时间': 'Create Time',
    '发送时间': 'Send Time',
    '完成时间': 'Complete Time',
    '定点上传': 'Fixed Upload',
    '每': 'Every',
    '月': 'Month',
    '日': 'Day',
    '的': 'of',
    '时': 'Hour',
    '上传': 'Upload',
    '注: 如果后面不选择的话就取消定点上传功能': 'Note: If not selected, the fixed upload function will be cancelled',
    '周期上传': 'Cyclic Upload',
    '上传时间': 'Upload Time',
    '至': 'to',
    '开始时间': 'Start Time',
    '结束时间': 'End Time',
    '选择时间范围': 'Select Time Range',
    '上传间隔': 'Upload Interval',
    '选择日期': 'Select Date',
    '冻结时间': 'Freeze Time',
    '上传日期': 'Upload Date',
    '选择月': 'Select Month',
    '日冻结时间': 'Daily Freeze Time',
    '选择时间': 'Select Time',
    '月冻结时间': 'Monthly Freeze Time',
    '累计总用量': 'Total Usage',
    '抄表时间': 'Meter Reading Time',
    '暂无数据': 'NoData',
    '表码数': 'Meter Reading',
    '保存': 'Save',
  },
  // 查询设备与抄收---查询设备日用水
  'QueryDailyUsage': {
    '表号': 'Meter Number',
    '统计日期': 'Statistical Date',
    '当日用量': 'Daily Usage',
    '当前表码数': 'Current Meter Reading',
    '是否结算': 'Settled',
    '设备日用量': 'Device Daily Usage',
    '重置': 'Reset',
    '是': 'Yes',
    '否': 'No',
    '至': 'to',
    '开始日期': 'Start Date',
    '结束日期': 'End Date'
  },
  // 财务报表 - 充值记录
  'financialReport': {
    'projectHome': 'Project Home',
    'financialReport': 'Financial Report',
    'rechargeRecord': 'Recharge Record',
    'search': 'Search',
    'areaExport': 'Area Export',
    'paymentId': 'Payment ID',
    'meterNumber': 'Meter Number',
    'username': 'Username',
    'address': 'Address',
    'time': 'Time',
    'amount': 'Payment/Refund Amount',
    'billType': 'Bill Type',
    'status': 'Status',
    'note': 'Note',
    'operation': 'Operation',
    'print': 'Print',
    'rechargeVoucher': 'Recharge Voucher',
    'orderNumber': 'Order Number',
    'receiptDate': 'Receipt Date',
    'deviceNumber': 'Device Number',
    'currentMeterReading': 'Current Meter Reading',
    'addressInfo': 'Address Info',
    'rechargeAmount': 'Recharge Amount',
    'accountBalance': 'Account Balance',
    'operator': 'Operator',
    'mobileScreenshot': 'You can take a screenshot as a voucher on mobile',
    'cancel': 'Cancel',
    '请输入关键字': 'Search',
    '项目首页': 'Project Home',
    '账务报表': 'Financial Report',
    '充值记录': 'Recharge Record',
    '区域导出': 'Area Export',
    '缴费编号': 'Payment ID',
    '水表编号': 'Meter Number',
    '用户姓名': 'Username',
    '地址': 'Address',
    '时间': 'Time',
    '交/退款金额': 'Payment/Refund Amount',
    '账单类型': 'Bill Type',
    '状态': 'Status',
    '备注': 'Note',
    '操作': 'Operation',
    '打印': 'Print',
    '充值凭证': 'Recharge Voucher',
    '订单编号': 'Order Number',
    '收款日期': 'Receipt Date',
    '设备编号': 'Device Number',
    '当前表码': 'Current Meter Reading',
    '地址信息': 'Address Info',
    '充值金额': 'Recharge Amount',
    '账户余额': 'Account Balance',
    '操作人员': 'Operator',
    '手机可以截个图作为凭证': 'You can take a screenshot as a voucher on mobile',
    '取消': 'Cancel',
  },
  // 财务报表 账单流水
  'BillFlow': {
    'projectHome': 'Project Home',
    'financialReport': 'Financial Report',
    'BillFlow': 'Bill Flow',
    'RegionalExport': 'Area Export',
    'paymentId': 'Payment ID',
    'meterNumber': 'Meter Number',
    'username': 'Username',
    'time': 'Time',
    'amount': 'Current Amount',
    'userAddress': 'User Address',
    'settlementWaterVolume': 'Settlement Water Volume',
    'meterReading': 'Meter Reading',
    'balance': 'Balance',
    'billType': 'Bill Type',
    'status': 'Status',
    'note': 'Note',
    'operation': 'Operation',
    'cancel': 'Cancel',
    'confirm': 'Confirm',
    'serialNumber': 'No.',
    'contactInfo': 'Contact Info',
    'waterType': 'Water Type',
    'onlineStatus': 'Online Status',
    'valveStatus': 'Valve Status',
    'positiveFlow': 'Positive Flow',
    'netFlow': 'Net Flow',
    'idNumber': 'ID Number',
    'cancelSuccess': 'Cancel Success',
    'BillFlowAreaInfoTable': 'Bill Flow Area Information Table',
    'exportSuccess': 'Export Success!',
    '项目首页': 'Project Home',
    '财务报表': 'Financial Report',
    '账单流水': 'Bill Flow',
    '区域导出': 'Area Export',
    '缴费编号': 'Payment ID',
    '水表编号': 'Meter Number',
    '用户姓名': 'Username',
    '时间': 'Time',
    '本次金额': 'Current Amount',
    '用户地址': 'User Address',
    '结算水量': 'Settlement Water Volume',
    '表码数': 'Meter Reading',
    '余额': 'Balance',
    '账单类型': 'Bill Type',
    '状态': 'Status',
    '备注': 'Note',
    '操作': 'Operation',
    '撤销': 'Cancel',
    '确定': 'Confirm',
    '序号': 'No.',
    '联系方式': 'Contact Info',
    '用水类型': 'Water Type',
    '在线状态': 'Online Status',
    '阀门状态': 'Valve Status',
    '正向累计流量': 'Positive Flow',
    '净累计流量': 'Net Flow',
    '证件号码': 'ID Number',
    '撤销成功': 'Cancel Success',
    '账单流水区域信息表': 'Bill Flow Area Information Table',
    '导出成功!': 'Export Success!',
  },
  // 售水日报
  'waterSalesDaily': {
    'projectHome': 'Project Home',
    'financialReport': 'Financial Report',
    'waterSalesDaily': 'Water Sales Daily',
    'totalWechatPayAmount': 'Total WeChat Payment Amount',
    'totalWechatPayCount': 'Total WeChat Payment Count',
    'totalBusinessWaterAmount': 'Total Business Water Amount',
    'totalBusinessWaterCount': 'Total Business Water Count',
    'totalDiscountWaterAmount': 'Total Discount Water Amount',
    'totalDiscountWaterCount': 'Total Discount Water Count',
    'totalSystemTransferAmount': 'Total System Transfer Amount',
    'totalSystemTransferCount': 'Total System Transfer Count',
    'totalPlatformRefundAmount': 'Total Platform Refund Amount',
    'totalPlatformRefundCount': 'Total Platform Refund Count',
    'wechatPayAmount': 'WeChat Payment Amount',
    'wechatPayCount': 'WeChat Payment Count',
    'businessWaterAmount': 'Business Water Amount',
    'businessWaterCount': 'Business Water Count',
    'discountWaterAmount': 'Discount Water Amount',
    'discountWaterCount': 'Discount Water Count',
    'systemTransferAmount': 'System Transfer Amount',
    'systemTransferCount': 'System Transfer Count',
    'platformRefundAmount': 'Platform Refund Amount',
    'platformRefundCount': 'Platform Refund Count',
    'statisticalTime': 'Statistical Time',
    'to': 'to',
    'startDate': 'Start Date',
    'endDate': 'End Date',
    'community': 'Community',
    'selectCommunity': 'Please select community',
    'building': 'Building',
    'selectBuilding': 'Please select building',
    'unit': 'Unit',
    'selectUnit': 'Please select unit',
    'room': 'Room',
    'selectRoom': 'Please select room',
    'search': 'Search',
    'reset': 'Reset',
    '至': 'to',
    '开始日期': 'Start Date',
    '结束日期': 'End Date',
    '小区': 'Community',
    '请选择小区': 'Please select community',
    '楼栋': 'Building',
    '请选择楼栋': 'Please select building',
    '单元': 'Unit',
    '请选择单元': 'Please select unit',
    '房间': 'Room',
    '请选择房间': 'Please select room',
    '查 询': 'Search',
    '重 置': 'Reset',
    '项目首页': 'Project Home',
    '账务报表': 'Financial Report',
    '售水日报': 'Water Sales Daily',
    '总微信支付金额': 'Total WeChat Payment Amount',
    '总微信支付次数': 'Total WeChat Payment Count',
    '总业务售水金额': 'Total Business Water Amount',
    '总业务售水次数': 'Total Business Water Count',
    '总优惠售水金额': 'Total Discount Water Amount',
    '总优惠售水次数': 'Total Discount Water Count',
    '总系统结转金额': 'Total System Transfer Amount',
    '总系统结转次数': 'Total System Transfer Count',
    '总平台退费金额': 'Total Platform Refund Amount',
    '总平台退费次数': 'Total Platform Refund Count',
    '微信支付金额': 'WeChat Payment Amount',
    '微信支付次数': 'WeChat Payment Count',
    '业务售水金额': 'Business Water Amount',
    '业务售水次数': 'Business Water Count',
    '优惠售水金额': 'Discount Water Amount',
    '优惠售水次数': 'Discount Water Count',
    '系统结转金额': 'System Transfer Amount',
    '系统结转次数': 'System Transfer Count',
    '平台退费金额': 'Platform Refund Amount',
    '平台退费次数': 'Platform Refund Count',
    '统计时间': 'Statistical Time',
  },
  // 售水月报
  'waterSalesMonthly': {
    'startMonth': 'Start Month',
    'endMonth': 'End Month',
    'community': 'Community',
    'selectCommunity': 'Select Community',
    'building': 'Building',
    'selectBuilding': 'Select Building',
    'unit': 'Unit',
    'selectUnit': 'Select Unit',
    'room': 'Room',
    'selectRoom': 'Select Room',
    'search': 'Search',
    'reset': 'Reset',
    'totalWechatAmount': 'Total WeChat Payment Amount',
    'totalWechatCount': 'Total WeChat Payment Count',
    'totalBusinessAmount': 'Total Business Sales Amount',
    'totalBusinessCount': 'Total Business Sales Count',
    'totalDiscountAmount': 'Total Discount Sales Amount',
    'totalDiscountCount': 'Total Discount Sales Count',
    'totalSystemAmount': 'Total System Transfer Amount',
    'totalSystemCount': 'Total System Transfer Count',
    'totalRefundAmount': 'Total Platform Refund Amount',
    'totalRefundCount': 'Total Platform Refund Count',
    'wechatAmount': 'WeChat Payment Amount',
    'wechatCount': 'WeChat Payment Count',
    'businessAmount': 'Business Sales Amount',
    'businessCount': 'Business Sales Count',
    'discountAmount': 'Discount Sales Amount',
    'discountCount': 'Discount Sales Count',
    'systemAmount': 'System Transfer Amount',
    'systemCount': 'System Transfer Count',
    'refundAmount': 'Platform Refund Amount',
    'refundCount': 'Platform Refund Count',
    'statisticsTime': 'Statistics Time',
    'selectTime': 'Please select a time period',
    '开始月份': 'Start Month',
    '结束月份': 'End Month',
    '小区': 'Community',
    '请选择小区': 'Select Community',
    '楼栋': 'Building',
    '请选择楼栋': 'Select Building',
    '单元': 'Unit',
    '请选择单元': 'Select Unit',
    '房间': 'Room',
    '请选择房间': 'Select Room',
    '查 询': 'Search',
    '重 置': 'Reset',
    '总微信支付金额': 'Total WeChat Payment Amount',
    '总微信支付次数': 'Total WeChat Payment Count',
    '总业务售水金额': 'Total Business Sales Amount',
    '总业务售水次数': 'Total Business Sales Count',
    '总优惠售水金额': 'Total Discount Sales Amount',
    '总优惠售水次数': 'Total Discount Sales Count',
    '总系统结转金额': 'Total System Transfer Amount',
    '总系统结转次数': 'Total System Transfer Count',
    '总平台退费金额': 'Total Platform Refund Amount',
    '总平台退费次数': 'Total Platform Refund Count',
    '微信支付金额': 'WeChat Payment Amount',
    '微信支付次数': 'WeChat Payment Count',
    '业务售水金额': 'Business Sales Amount',
    '业务售水次数': 'Business Sales Count',
    '优惠售水金额': 'Discount Sales Amount',
    '优惠售水次数': 'Discount Sales Count',
    '系统结转金额': 'System Transfer Amount',
    '系统结转次数': 'System Transfer Count',
    '平台退费金额': 'Platform Refund Amount',
    '平台退费次数': 'Platform Refund Count',
    '统计时间': 'Statistics Time',
    '请选择时间': 'Please select a time period',
  },
  'annualReport': {
    'selectTime': 'Select Time',
    'selectYear': 'Select Year',
    'community': 'Community',
    'selectCommunity': 'Please select community',
    'building': 'Building',
    'selectBuilding': 'Please select building',
    'unit': 'Unit',
    'selectUnit': 'Please select unit',
    'room': 'Room',
    'selectRoom': 'Please select room',
    'search': 'Search',
    'reset': 'Reset',
    'totalWechatPayAmount': 'Total WeChat Payment Amount',
    'totalWechatPayCount': 'Total WeChat Payment Count',
    'totalBusinessWaterAmount': 'Total Business Water Sales Amount',
    'totalBusinessWaterCount': 'Total Business Water Sales Count',
    'totalDiscountWaterAmount': 'Total Discount Water Sales Amount',
    'totalDiscountWaterCount': 'Total Discount Water Sales Count',
    'totalSystemTransferAmount': 'Total System Transfer Amount',
    'totalSystemTransferCount': 'Total System Transfer Count',
    'totalPlatformRefundAmount': 'Total Platform Refund Amount',
    'totalPlatformRefundCount': 'Total Platform Refund Count',
    'wechatPayAmount': 'WeChat Payment Amount',
    'wechatPayCount': 'WeChat Payment Count',
    'businessWaterAmount': 'Business Water Sales Amount',
    'businessWaterCount': 'Business Water Sales Count',
    'discountWaterAmount': 'Discount Water Sales Amount',
    'discountWaterCount': 'Discount Water Sales Count',
    'systemTransferAmount': 'System Transfer Amount',
    'systemTransferCount': 'System Transfer Count',
    'platformRefundAmount': 'Platform Refund Amount',
    'platformRefundCount': 'Platform Refund Count',
    'statisticsTime': 'Statistics Time',
    'selectTimeError': 'Please select time',
    '选择时间': 'Select Time',
    '选择年': 'Select Year',
    '小区': 'Community',
    '请选择小区': 'Please select community',
    '楼栋': 'Building',
    '请选择楼栋': 'Please select building',
    '单元': 'Unit',
    '请选择单元': 'Please select unit',
    '房间': 'Room',
    '请选择房间': 'Please select room',
    '查 询': 'Search',
    '重 置': 'Reset',
    '总微信支付金额': 'Total WeChat Payment Amount',
    '总微信支付次数': 'Total WeChat Payment Count',
    '总业务售水金额': 'Total Business Water Sales Amount',
    '总业务售水次数': 'Total Business Water Sales Count',
    '总优惠售水金额': 'Total Discount Water Sales Amount',
    '总优惠售水次数': 'Total Discount Water Sales Count',
    '总系统结转金额': 'Total System Transfer Amount',
    '总系统结转次数': 'Total System Transfer Count',
    '总平台退费金额': 'Total Platform Refund Amount',
    '总平台退费次数': 'Total Platform Refund Count',
    '微信支付金额': 'WeChat Payment Amount',
    '微信支付次数': 'WeChat Payment Count',
    '业务售水金额': 'Business Water Sales Amount',
    '业务售水次数': 'Business Water Sales Count',
    '优惠售水金额': 'Discount Water Sales Amount',
    '优惠售水次数': 'Discount Water Sales Count',
    '系统结转金额': 'System Transfer Amount',
    '系统结转次数': 'System Transfer Count',
    '平台退费金额': 'Platform Refund Amount',
    '平台退费次数': 'Platform Refund Count',
    '统计时间': 'Statistics Time',
    '请选择时间': 'Please select time',
  },
  // 用水类型管理 - 英文翻译
  'waterType': {
    'projectHome': 'Project Home',
    'basicData': 'Basic Data',
    'waterType': 'Water Type',
    'waterTypeManagement': 'Water Type Management',
    'addWaterType': 'Add Water Type',
    'loading': 'Loading',
    'waterTypeName': 'Water Type',
    'ladderType': 'Ladder Type',
    'fixed': 'Fixed',
    'ladder': 'Ladder',
    'monthlyFixedFee': 'Monthly Fixed Fee',
    'monthlyIncludedWater': 'Monthly Included Water',
    'operation': 'Operation',
    'delete': 'Delete',
    'view': 'View',
    // 添加对话框
    'addLadder': 'Add Ladder',
    'name': 'Name',
    'waterTypePlaceholder': 'Water Type',
    'monthlyFee': 'Monthly Fee',
    'yuan': 'Yuan',
    'includedWater': 'Included Water',
    'cubicMeter': 'm³',
    'feeNote': 'Note: If you enter 0 yuan, it means 0 yuan',
    // 阶梯类型标签
    'flatPrice': 'Flat Price',
    'monthlyLadder': 'Monthly Ladder',
    'annualLadder': 'Annual Ladder',
    // 阶梯表单
    'ladderOne': 'Ladder One',
    'ladderTwo': 'Ladder Two',
    'ladderThree': 'Ladder Three',
    'ladderFour': 'Ladder Four',
    'ladderFive': 'Ladder Five',
    'price': 'Price',
    'inputStageOne': 'Enter Stage One',
    'inputStageTwo': 'Enter Stage Two',
    'inputStageThree': 'Enter Stage Three',
    'inputStageFour': 'Enter Stage Four',
    'inputStageFive': 'Enter Stage Five',
    'inputPrice': 'Enter Price',
    'flatPriceNote': 'Note: To add flat price, click on Flat Price tab to input.',
    // 按钮
    'reselect': 'Reselect',
    'save': 'Save',
    // 查看对话框
    'viewDetails': 'View Details',
    'modify': 'Modify',
    'close': 'Close',
    'modifyNote': 'Note: To modify flat price/monthly ladder or annual ladder, select the type you want to modify before clicking the modify button.',
    // 提示框
    'confirmDelete': 'This operation will permanently delete this ladder, continue?',
    'tip': 'Tip',
    'confirm': 'Confirm',
    'cancel': 'Cancel',
    'deleteSuccess': 'Deleted Successfully',
    'cancelDelete': 'Delete Cancelled',
    'addSuccess': 'Added Successfully',
    'modifySuccess': 'Modified Successfully',
    '元': 'Yuan',
    '项目首页': 'Project Home',
    '基础资料': 'Basic Data',
    '用水类型': 'Water Type',
    '用水类型管理': 'Water Type Management',
    '新增用水类型': 'Add Water Type',
    '拼命加载中': 'Loading',
    '阶梯类型': 'Ladder Type',
    '固定': 'Fixed',
    '阶梯': 'Ladder',
    '月固定费': 'Monthly Fee',
    '月含水量': 'Monthly Included Water',
    '操作': 'Operation',
    '删除': 'Delete',
    '查看': 'View',
    '新增阶梯': 'Add Ladder',
    '名称': 'Name',
    '含水量': 'Included Water',
    '方': 'm³',
    '注: 如果输入0元则是0元': 'Note: If you enter 0 yuan, it means 0 yuan',
    '平价': 'Flat Price',
    '月阶梯': 'Monthly Ladder',
    '阶梯一': 'Ladder One',
    '请输入阶段一': 'Enter Stage One',
    '价格': 'Price',
    '请输入价格': 'Enter Price',
    '阶梯二': 'Ladder Two',
    '请输入阶段二': 'Enter Stage Two',
    '阶梯三': 'Ladder Three',
    '请输入阶段三': 'Enter Stage Three',
    '阶梯四': 'Ladder Four',
    '请输入阶段四': 'Enter Stage Four',
    '阶梯五': 'Ladder Five',
    '请输入阶段五': 'Enter Stage Five',
    '年阶梯': 'Annual Ladder',
    '注: 如要添加平价，需要点击平价后则可进行输入。': 'Note: To add flat price, click on Flat Price tab to input.',
    '重 选': 'Reselect',
    '保 存': 'Save',
    '查看详情': 'View Details',
    '注: 如要修改平价/月阶梯或年阶梯，需要在点击修改前选择好要修改的平价/月阶梯或年阶梯则可进行修改。': 'Note: To modify flat price/monthly ladder or annual ladder, select the type you want to modify before clicking the modify button.',
    '修 改': 'Modify',
    '关闭': 'Close',
    '修改成功': 'Modified Successfully',
    '添加成功': 'Added Successfully',
    '此操作将永久删除该阶梯, 是否继续?': 'This operation will permanently delete this ladder, continue?',
    '提示': 'Tip',
    '确定': 'Confirm',
    '取消': 'Cancel',
    '删除成功': 'Deleted Successfully',
    '已取消删除': 'Delete Cancelled',
  },
  // 基础资料--位置信息
  'positionInfo': {
    'projectHome': 'Project Home',
    'basicData': 'Basic Data',
    'locationInfo': 'Location Info',
    '小区': 'Community',
    '楼栋': 'Building',
    '单元': 'Unit',
    '房间': 'Room',
    'search': 'Search',
    'query': 'Query',
    'add': 'Add',
    '修改': 'Modify',
    'delete': 'Delete',
    '小区名称': 'CommunityName',
    '楼栋名称': 'BuildingName',
    'unitName': 'Unit Name',
    'roomName': 'Room Name',
    'operation': 'Operation',
    'infoEdit': 'Info Edit',
    '信息修改': 'InfoModify',
    'save': 'Save',
    '请选择小区': 'PleaseSelectCommunity',
    'selectBuilding': 'Please Select Building',
    'confirmDelete': 'This operation will permanently delete this location, continue?',
    'tip': 'Tip',
    'confirm': 'Confirm',
    'cancel': 'Cancel',
    'deleteSuccess': 'Deleted Successfully',
    'cancelDelete': 'Delete Cancelled',
    'addSuccess': 'Added Successfully',
    'modifySuccess': 'Modified Successfully',
    '项目首页': 'Project Home',
    '基础资料': 'Basic Data',
    '位置信息': 'Location Info',
    '请搜索': 'Search',
    '查询': 'Query',
    '添加': 'Add',
    '操作': 'Operation',
    '删除': 'Delete',
    '单元名称': 'Unit Name',
    '房间名称': 'Room Name',
    '保存': 'Save',
    '请选择楼栋': 'Please Select Building',
    '信息编辑': 'Info Edit',
    '此操作将永久删除该位置, 是否继续?': 'This operation will permanently delete this location, continue?',
    '提示': 'Tip',
    '确定': 'Confirm',
    '取消': 'Cancel',
    '删除成功': 'Deleted Successfully',
    '已取消删除': 'Delete Cancelled',
    '添加成功': 'Added Successfully',
    '修改成功': 'Modified Successfully',
  },
  // 表具类型
  'gaugetype': {
    'projectHome': 'Project Home',
    'basicData': 'Basic Data',
    'meterType': 'Meter Type',
    'model': 'Model',
    'add': 'Add',
    'modify': 'Modify',
    'delete': 'Delete',
    'infoEdit': 'Information Edit',
    'save': 'Save',
    'confirmDelete': 'This operation will permanently delete this user, continue?',
    'tip': 'Tip',
    'confirm': 'Confirm',
    'cancel': 'Cancel',
    'cancelDelete': 'Delete Cancelled',
    '项目首页': 'Project Home',
    '基础资料': 'Basic Data',
    '表具类型': 'Meter Type',
    '添加': 'Add',
    '型号': 'Model',
    '修改': 'Modify',
    '删除': 'Delete',
    '信息编辑': 'Information Edit',
    '保存': 'Save',
    '此操作将永久删除该表具类型, 是否继续?': 'This operation will permanently delete this user, continue?',
    '提示': 'Tip',
    '确定': 'Confirm',
    '取消': 'Cancel',
    '已取消删除': 'Delete Cancelled',
  },
  // 水表档案
  'waterMeterFile': {
    '项目首页': 'ProjectHome',
    'basicData': 'BasicData',
    'waterMeterFile': 'WaterMeterArchive',
    '批量添加': 'BatchAdd',
    '单条添加': 'SingleAdd',
    'selectedExport': 'ExportSelected',
    'areaExport': 'ExportArea',
    'batchEnable': 'BatchEnable',
    'batchDisable': 'BatchDisable',
    'addValveControlWhitelist': 'AddValveControlWhitelist',
    '缴费编号': 'PaymentID',
    '水表编号': 'MeterID',
    '用户姓名': 'Username',
    '联系方式': 'Contact',
    '余额': 'Balance',
    '启用状态': 'EnableStatus',
    '用水类型': 'WaterType',
    '在线状态': 'OnlineStatus',
    '阀门状态': 'ValveStatus',
    '上传失败次数': 'UploadFailCount',
    '定时冻结间隔': 'FreezeInterval',
    '压力': 'Pressure',
    '水温': 'WaterTemperature',
    '用户地址': 'Address',
    '正向累计流量': 'ForwardFlow',
    '净累计流量': 'NetFlow',
    '证件号码': 'IDNumber',
    '拆卸状态': 'DisassemblyStatus',
    '漏水': 'Leakage',
    '反向计量': 'ReverseMetering',
    '流量超限': 'FlowExceed',
    '液位报警': 'liquidLevelAlarm',
    'operation': 'Operation',
    '修改': 'Modify',
    'view': 'View',
    'enabled': 'Enabled',
    'disabled': 'Disabled',
    'selectWaterType': 'Please Select',
    // 批量导入弹窗
    'dragOrClick': 'Drag file here, or click to upload',
    'onlyUploadXls': 'Only upload xls/xlsx files',
    'downloadTemplate': 'Click to download template',
    // 批量添加结果弹窗
    'successCount': 'Success Count',
    'failCount': 'Failure Count',
    'errorInfo': 'Error Information',
    // 批量启用/停用弹窗
    'currentSelection': 'Current Selection',
    'devices': 'devices',
    'selectAllDevices': 'Select all devices in current area',
    'records': 'records',
    'waterTypeLabel': 'Water Type',
    // 添加白名单弹窗
    'whitelistDescription': 'Note: The meters in the valve control whitelist will not be automatically closed',
    'add': 'Add',
    '基础资料': 'BasicData',
    '水表档案': 'WaterMeterArchive',
    '批量启用': 'BatchEnable',
    '批量停用': 'BatchDisable',
    '添加阀控策略白名单': 'AddValveControlWhitelist',
    '选中导出': 'ExportSelected',
    '区域导出': 'ExportArea',
    '停用': 'Disabled',
    '启用': 'Enabled',
    '操作': 'Operation',
    '查看': 'View',
    '将文件拖到此处，或点击上传': 'Drag file here, or click to upload',
    '只能上传xls/xlsx文件': 'Only upload xls/xlsx files',
    '点击下载模板文件': 'Click to download template',
    '成功条数': 'Success Count',
    '失败条数': 'Failure Count',
    '错误信息': 'Error Information',
    '当前勾选': 'Current Selection',
    '台设备': 'devices',
    '选择当前区域所有设备': 'Select all devices in current area',
    '条': 'records',
    '请选择': 'Please Select',
    '说明：阀控策略白名单内的表将不会自动关阀': 'Note: The meters in the valve control whitelist will not be automatically closed',
    '添加': 'Add',
  },
  // 水表地址组件
  'waterAddress': {
    'community': 'Community',
    'selectCommunity': 'Select Community',
    'building': 'Building',
    'selectBuilding': 'Select Building',
    'unit': 'Unit',
    'selectUnit': 'Select Unit',
    'room': 'Room',
    'selectRoom': 'Select Room',
    'owingStatus': 'Owing Status',
    'pleaseSelectWhetherOwing': 'Please Select Whether Owing',
    'all': 'All',
    'owing': 'Owing',
    'notOwing': 'Not Owing',
    'waterType': 'Water Type',
    'pleaseSelect': 'Please Select',
    'search': 'Search',
    'reset': 'Reset',
    '查询': 'Search',
    '重置': 'Reset',
    '用水类型': 'Water Type',
    '请选择': 'Please Select',
    '欠费状态': 'Owing Status',
    '请选择是否欠费': 'Please Select Whether Owing',
    '小区': 'Community',
    '请选择小区': 'Select Community',
    '楼栋': 'Building',
    '请选择楼栋': 'Select Building',
    '单元': 'Unit',
    '请选择单元': 'Select Unit',
    '房间': 'Room',
    '请选择房间': 'Select Room',
    '全部': 'All',
    '欠费': 'Owing',
    '不欠费': 'Not Owing',
  },
  // 水表档案--单条添加
  'waterAddition': {
    'meterIdLabel': 'Meter ID : ',
    'enterMeterId': 'Please enter meter ID',
    'modelLabel': 'Model : ',
    'selectModel': 'Please select model',
    'waterTypeLabel': 'Water Type : ',
    'selectWaterType': 'Please select water type',
    'meterStatusLabel': 'Meter Status : ',
    'selectMeterStatus': 'Please select meter status',
    'nameLabel': 'Name:',
    'enterName': 'Please enter name',
    'phoneLabel': 'Phone:',
    'enterPhone': 'Please enter phone',
    'idCardLabel': 'ID Card:',
    'enterIdCard': 'Please enter ID card',
    'communityLabel': 'Community:',
    'selectCommunity': 'Please select community',
    'buildingLabel': 'Building:',
    'selectBuilding': 'Please select building',
    'unitLabel': 'Unit:',
    'selectUnit': 'Please select unit',
    'roomLabel': 'Room:',
    'selectRoom': 'Please select room',
    'save': 'Save',
    'infoEdit': 'Information Edit',
    'communityNameLabel': 'Community Name: ',
    'buildingNameLabel': 'Building Name: ',
    'unitNameLabel': 'Unit Name: ',
    'roomNameLabel': 'Room Name: ',
    'addSuccess': 'Added Successfully',
    'addCommunitySuccess': 'Community added successfully',
    'addBuildingSuccess': 'Building added successfully',
    'addUnitSuccess': 'Unit added successfully',
    'addRoomSuccess': 'Room added successfully',
    '表具编码': 'Meter ID : ',
    '请输入表具编码': 'Please enter meter ID',
    '型号': 'Model : ',
    '请选择型号': 'Please select model',
    '用水类型': 'Water Type : ',
    '请选择用水类型': 'Please select water type',
    '水表状态': 'Meter Status : ',
    '请选择水表状态': 'Please select meter status',
    '姓名': 'Name:',
    '请输入姓名': 'Please enter name',
    '联系电话': 'Phone:',
    '请输入电话': 'Please enter phone',
    '证件号码': 'ID Card:',
    '请输入证件号码': 'Please enter ID card',
    '小区': 'Community:',
    '请选择小区': 'Please select community',
    '楼栋': 'Building:',
    '请选择楼栋': 'Please select building',
    '单元': 'Unit:',
    '请选择单元': 'Please select unit',
    '房间': 'Room:',
    '请选择房间': 'Please select room',
    '保 存': 'Save',
    '信息编辑': 'Information Edit',
    '小区名称: ': 'Community Name: ',
    '楼栋名称': 'Building Name: ',
    '单元名称': 'Unit Name: ',
    '房间名称': 'Room Name: ',
    '添加成功': 'Added Successfully',
    '添加小区成功': 'Community added successfully',
    '添加楼栋成功': 'Building added successfully',
    '添加单元成功': 'Unit added successfully',
    '添加楼房间成功': 'Room added successfully',
  },
  // 水表档案--修改
  'modify': {
    'title': 'Unbind Water Meter',
    'meterCode': 'Meter Code : ',
    'enterMeterCode': 'Please enter meter code',
    'modelType': 'Model Type : ',
    'selectWaterType': 'Please select water type',
    'waterType': 'Water Type : ',
    'meterStatus': 'Meter Status : ',
    'selectMeterStatus': 'Please select meter status',
    'userName': 'Name:',
    'enterName': 'Please enter name',
    'contactPhone': 'Contact Phone:',
    'enterPhone': 'Please enter phone',
    'idNumber': 'ID Number:',
    'enterId': 'Please enter ID number',
    'community': 'Community:',
    'selectCommunity': 'Please select community',
    'building': 'Building:',
    'selectBuilding': 'Please select building',
    'unit': 'Unit:',
    'selectUnit': 'Please select unit',
    'room': 'Room:',
    'selectRoom': 'Please select room',
    'locationNote': 'Note: If location is not selected, the previous location will be saved',
    'save': 'Save',
    'disabled': 'Disabled',
    'enabled': 'Enabled',
    'infoEdit': 'Information Edit',
    'communityName': 'Community Name: ',
    'buildingName': 'Building Name: ',
    'unitName': 'Unit Name: ',
    'roomName': 'Room Name: ',
    'successTitle': 'Success',
    'modifySuccess': 'Modified successfully',
    'addCommunitySuccess': 'Community added successfully',
    'addBuildingSuccess': 'Building added successfully',
    'addUnitSuccess': 'Unit added successfully',
    'addRoomSuccess': 'Room added successfully',
    '表具编码': 'Meter Code : ',
    '请输入表具编码': 'Please enter meter code',
    '型号': 'Model Type : ',
    '请选择用水类型': 'Please select water type',
    '用水类型': 'Water Type : ',
    '水表状态': 'Meter Status : ',
    '请选择水表状态': 'Please select meter status',
    '姓名': 'Name:',
    '请输入姓名': 'Please enter name',
    '联系电话': 'Contact Phone:',
    '请输入电话': 'Please enter phone',
    '证件号码': 'ID Number:',
    '请输入证件号码': 'Please enter ID number',
    '小区': 'Community:',
    '请选择小区': 'Please select community',
    '楼栋': 'Building:',
    '请选择楼栋': 'Please select building',
    '单元': 'Unit:',
    '请选择单元': 'Please select unit',
    '房间': 'Room:',
    '请选择房间': 'Please select room',
    '注：如果不选择位置则保存之前的位置': 'Note: If location is not selected, the previous location will be saved',
    '保 存': 'Save',
    '信息编辑': 'Information Edit',
    '小区名称: ': 'Community Name: ',
    '楼栋名称': 'Building Name: ',
    '单元名称': 'Unit Name: ',
    '房间名称': 'Room Name: ',
    '成功': 'Success',
    '修改成功': 'Modified successfully',
    '添加小区成功': 'Community added successfully',
    '添加楼栋成功': 'Building added successfully',
    '添加单元成功': 'Unit added successfully',
    '添加楼房间成功': 'Room added successfully',
  },
  // 水表档案详情页
  'fileDetails': {
    'projectHome': 'Project Home',
    'basicData': 'Basic Data',
    'waterMeterFile': 'Water Meter Archive',
    'fileDetails': 'Archive Details',
    'back': 'Back',
    'meterId': 'Meter ID',
    'detailInfo': 'Detail Information',
    'waterType': 'Water Type',
    'totalFlow': 'Total Flow',
    'balance': 'Balance',
    'onlineStatus': 'Online Status',
    'valveStatus': 'Valve Status',
    'meterType': 'Meter Type',
    'meterStatus': 'Meter Status',
    'netAccumulation': 'Net Accumulation',
    'reverseAccumulation': 'Reverse Accumulation',
    'atAccumulation': 'Instant Flow',
    'batteryVoltage': 'Battery Voltage',
    'signalStrength': 'Signal Strength',
    'powerDown': 'Power Down',
    'powerLow': 'Low Power',
    'magneticAttack': 'Magnetic Attack',
    'note': 'Note: Enabled meter status means the meter is in normal use and will be charged. Disabled means the meter is in normal use but will not be charged.',
    'delete': 'Delete',
    'save': 'Save',
    'billFlow': 'Bill Flow',
    'meterReading': 'Meter Reading',
    'switchValve': 'Valve Switch Record',
    '设备日用量': 'DailyConsumptionOfEquipment',
    'deleteConfirm': 'Current meter balance is {balance}, do you want to delete this meter archive? (Please decide whether to settle the account before deletion)',
    'deleteSuccess': 'Delete Successfully',
    'saveSuccess': 'Modified Successfully',
    '项目首页': 'Project Home',
    '基础资料': 'Basic Data',
    '水表档案': 'Water Meter Archive',
    '档案详情': 'Archive Details',
    '返回': 'Back',
    '水表编号': 'Meter ID',
    '详情信息': 'Detail Information',
    '用水类型': 'Water Type',
    '累计流量': 'Total Flow',
    '余额': 'Balance',
    '在线状态': 'Online Status',
    '阀门状态': 'Valve Status',
    '表具类型': 'Meter Type',
    '水表状态': 'Meter Status',
    '净累计流量': 'Net Accumulation',
    '反向累计流量': 'Reverse Accumulation',
    '瞬时流量': 'Instant Flow',
    '电池电压': 'Battery Voltage',
    '信号强度': 'Signal Strength',
    '掉电状态': 'Power Down',
    '低压状态': 'Low Power',
    '磁攻击': 'Magnetic Attack',
    '注：水表状态启用指水表正常使用，开始扣费。停用指水表正常使用，停止扣费。': 'Note: Enabled meter status means the meter is in normal use and will be charged. Disabled means the meter is in normal use but will not be charged.',
    '删 除': 'Delete',
    '保 存': 'Save',
    '账单流水': 'Bill Flow',
    '抄表记录': 'Meter Reading',
    '开关阀记录': 'Valve Switch Record',
    '删除成功': 'Delete Successfully',
    '更改成功': 'Modified Successfully',
  },
  // 开关阀记录
  'switch': {
    'serialNumber': 'Serial Number',
    'meterId': 'Meter ID',
    'commandType': 'Operation Content',
    'status': 'Operation Result',
    'createTime': 'Create Time',
    'sendTime': 'Send Time',
    'completeTime': 'Complete Time',
    '响应结果': 'ResponseResult',
    'loading': 'Loading',
    '拼命加载中': 'Loading',
    '表具编号': 'Meter ID',
    '操作内容': 'Operation Content',
    '操作结果': 'Operation Result',
    '创建时间': 'Create Time',
    '发送时间': 'Send Time',
    '完成时间': 'Complete Time',
  },
  // 账单流水
  'records': {
    'paymentId': 'Payment ID',
    'meterId': 'Meter ID',
    'username': 'Username',
    'time': 'Time',
    'amount': 'Amount',
    'address': 'Address',
    'flow_use': 'Settlement Flow',
    'current_sum_flow': 'Meter Reading',
    'aft_money': 'Balance',
    'type': 'Bill Type',
    'status': 'Status',
    'note': 'Note',
    '缴费编号': 'Payment ID',
    '水表编号': 'Meter ID',
    '用户姓名': 'Username',
    '时间': 'Time',
    '本次金额': 'Amount',
    '用户地址': 'Address',
    '结算水量': 'Settlement Flow',
    '表码数': 'Meter Reading',
    '余额': 'Balance',
    '账单类型': 'Bill Type',
    '状态': 'Status',
    '备注': 'Note',
  },
  // 抄表记录
  'meterRecord': {
    'index': 'No.',
    'meterId': 'Meter ID',
    'sumFlow': 'Total Usage',
    'unit': 'Unit',
    'plotReceiveTime': 'Meter Reading Time',
    'netAccumulation': 'Net Accumulation',
    'reverseAccumulation': 'Reverse Accumulation',
    'atAccumulation': 'Instant Flow',
    'batteryVoltage': 'Battery Voltage',
    'signalIntensity': 'Signal Intensity',
    'powerDown': 'Power Down',
    'powerLow': 'Low Power',
    'magneticAttack': 'Magnetic Attack',
    'valveStatus': 'Valve Status',
    'loading': 'Loading',
    '拼命加载中': 'Loading',
    '表具编号': 'Meter ID',
    '累计总用量': 'Total Usage',
    '单位': 'Unit',
    '抄表时间': 'Meter Reading Time',
    '净累计流量': 'Net Accumulation',
    '反向累计流量': 'Reverse Accumulation',
    '瞬时流量': 'Instant Flow',
    '电池电压': 'Battery Voltage',
    '信号强度': 'Signal Intensity',
    '掉电状态': 'Power Down',
    '低压状态': 'Low Power',
    '磁攻击': 'Magnetic Attack',
    '阀门状态': 'Valve Status',
  },
  // 阀控策略页面
  'strategy': {
    'viewWhitelist': 'View Valve Control Strategy Whitelist',
    'name': 'Name',
    'autoCloseValveForArrears': 'Auto Close Valve For Arrears',
    'alarmCloseValveStandard': 'Alarm Close Valve Standard',
    'oweCloseValveStandard': 'Owe Close Valve Standard',
    'operation': 'Operation',
    'modify': 'Modify',
    'accountEdit': 'Account Edit',
    'selectOweOrNot': 'Select Owe or Not',
    'alarmCloseValveRemainingAmount': 'Alarm Close Valve Remaining Amount',
    'oweCloseValveRemainingAmount': 'Owe Close Valve Remaining Amount',
    'currency': 'Yuan',
    'save': 'Save',
    'valveControlWhitelist': 'Valve Control Strategy Whitelist',
    'enterMeterNumber': 'Enter Meter Number',
    'search': 'Search',
    'refresh': 'Refresh',
    'meterNumber': 'Meter Number',
    'remove': 'Remove',
    '查看阀控策略白名单': 'View Valve Control Strategy Whitelist',
    '名称': 'Name',
    '欠费自动关阀': 'Auto Close Valve For Arrears',
    '报警关阀标准': 'Alarm Close Valve Standard',
    '欠费自动关阀标准': 'Owe Close Valve Standard',
    '操作': 'Operation',
    '修改': 'Modify',
    '账号编辑': 'Account Edit',
    '请选择是否欠费': 'Select Owe or Not',
    '报警关阀剩余量': 'Alarm Close Valve Remaining Amount',
    '元': 'Yuan',
    '欠费自动关阀剩余量': 'Owe Close Valve Remaining Amount',
    '保 存': 'Save',
    '阀控策略白名单': 'Valve Control Strategy Whitelist',
    '请输入表号': 'Enter Meter Number',
    '查询': 'Search',
    '刷新': 'Refresh',
    '表号': 'Meter Number',
    '移除': 'Remove',
  },
  // 账户管理
  'userGement': {
    'projectHome': 'Project Home',
    'systemManagement': 'System Management',
    'accountManagement': 'Account Management',
    'addInfo': 'Add Info',
    'userSettings': 'User Settings',
    'username': 'Username',
    'password': 'Password',
    'save': 'Save',
    'id': 'ID',
    'projectName': 'Project Name',
    'createDate': 'Create Date',
    'isAdmin': 'Is Admin',
    'operation': 'Operation',
    '修改': 'Modify',
    '删除': 'Delete',
    'userModify': 'User Modify',
    'deleteConfirm': 'This operation will permanently delete the user. Continue?',
    'tip': 'Tip',
    'confirm': 'Confirm',
    'cancel': 'Cancel',
    'deleteSuccess': 'Delete Successful',
    'deleteCancel': 'Delete Cancelled',
    'modifySuccessRedirect': 'Modification successful, redirecting to login page!!!',
    'modifySuccess': 'Modification successful!!!',
    'addSuccess': 'Added Successfully',
    'yes': 'Yes',
    'no': 'No',
    '项目首页': 'Project Home',
    '系统管理': 'System Management',
    '账户管理': 'Account Management',
    '添加信息': 'Add Info',
    '用户设置': 'User Settings',
    '用户名': 'Username',
    '密码': 'Password',
    '保 存': 'Save',
    '所属项目': 'Project Name',
    '创建日期': 'Create Date',
    '是否为管理员': 'Is Admin',
    '是': 'Yes',
    '否': 'No',
    '操作': 'Operation',
    '用户修改': 'User Modify',
    '此操作将永久删除该用户, 是否继续?': 'This operation will permanently delete the user. Continue?',
    '提示': 'Tip',
    '确定': 'Confirm',
    '取消': 'Cancel',
    '删除成功': 'Delete Successful',
    '已取消删除': 'Delete Cancelled',
    '修改成功,跳转到登录页面！！！': 'Modification successful, redirecting to login page!!!',
    '修改成功！！！': 'Modification successful!!!',
    '添加成功': 'Added Successfully',
  },
  // 全局配置
  'globalConfig': {
    'projectHome': 'Project Home',
    'systemManagement': 'System Management',
    'globalConfiguration': 'Global Configuration',
    'name': 'Name',
    'address': 'Address',
    'merchantId': 'Merchant ID',
    'wechatAppId': 'WeChat App ID',
    'balanceTipStandard': 'Balance Warning Standard',
    'operation': 'Operation',
    'modify': 'Modify',
    'uploadLogo': 'Upload Logo',
    'accountEdit': 'Account Edit',
    'projectName': 'Project Name',
    'projectAddress': 'Project Address',
    'balanceInsufficientAmount': 'Balance Insufficient Amount',
    'currency': 'Yuan',
    'save': 'Save',
    'modifySuccess': 'Modified Successfully',
    'uploadImage': 'Upload Image',
    'confirm': 'Confirm',
    'uploadNote': 'Note: Only images can be uploaded and must not exceed 10MB',
    'pleaseSelectImage': 'Please select an image for upload',
    '项目首页': 'Project Home',
    '系统管理': 'System Management',
    '全局配置': 'Global Configuration',
    '名称': 'Name',
    '地址': 'Address',
    '商户号': 'Merchant ID',
    '公众号id': 'WeChat App ID',
    '余额不足标准': 'Balance Warning Standard',
    '操作': 'Operation',
    '修改': 'Modify',
    '上传logo': 'Upload Logo',
    '账号编辑': 'Account Edit',
    '项目名称': 'Project Name',
    '项目地址': 'Project Address',
    '余额不足剩余量': 'Balance Insufficient Amount',
    '元': 'Yuan',
    '保 存': 'Save',
    '确定': 'Confirm',
    '注：只能上传图片 且不得大于10MB': 'Note: Only images can be uploaded and must not exceed 10MB',
    '请选择图片在进行上传': 'Please select an image for upload',
    '修改成功': 'Modified Successfully',
  },
  // 预警推送
  'alertPush': {
    'projectHome': 'Project Home',
    'systemManagement': 'System Management',
    'alertPush': 'Alert Push',
    'bindWechat': 'Bind WeChat Receiver',
    'refresh': 'Refresh',
    'id': 'ID',
    'wechatNickname': 'WeChat User Nickname',
    'wechatOpenid': 'WeChat User Openid',
    'projectName': 'Project Name',
    'bindTime': 'Binding Time',
    'operation': 'Operation',
    'delete': 'Delete',
    'bindTitle': 'Bind WeChat Receiver',
    'scanQRCode': 'Please scan the QR code with WeChat. After binding successfully, close this window and click the refresh button.',
    'scanNote': 'Note: Before using this feature, you must follow the WeChat official account corresponding to this project, otherwise you cannot receive alert information',
    'close': 'Close',
    'deleteConfirm': 'This operation will permanently delete this user. Continue?',
    'tip': 'Tip',
    'confirm': 'Confirm',
    'cancel': 'Cancel',
    'deleteSuccess': 'Delete Successful',
    'deleteCancel': 'Delete Cancelled',
    '项目首页': 'Project Home',
    '系统管理': 'System Management',
    '预警推送': 'Alert Push',
    '绑定接收者微信': 'Bind WeChat Receiver',
    '刷 新': 'Refresh',
    '请使用微信扫码，显示绑定成功后关闭此窗口并点击刷新按钮。': 'Please scan the QR code with WeChat. After binding successfully, close this window and click the refresh button.',
    '注意：使用此功能前必须先关注此项目对应的微信公众号，否则无法接收预警信息': 'Note: Before using this feature, you must follow the WeChat official account corresponding to this project, otherwise you cannot receive alert information',
    '关 闭': 'Close',
    '微信用户昵称': 'WeChat User Nickname',
    '微信用户openid': 'WeChat User Openid',
    '项目名称': 'Project Name',
    '绑定时间': 'Binding Time',
    '操作': 'Operation',
    '删 除': 'Delete',
    '此操作将永久删除该预警推送者, 是否继续?': 'This operation will permanently delete this user. Continue?',
    '提示': 'Tip',
    '确定': 'Confirm',
    '取消': 'Cancel',
    '删除成功': 'Delete Successful',
    '已取消删除': 'Delete Cancelled',
  },
  'message': {
    'success': 'Success',
    '成功': 'Success',
    '导出成功': '导出成功',
  },
  // 通用
  'common': {
    'rangeSeparator': 'to',
    'userLoginElsewhere': 'User logged in elsewhere',
    '用户在别处登录': 'User logged in elsewhere',
    '至': 'to',
  },
  // 图表相关
  'chart': {
    'dayData': ' day data: ',
    'waterUsage': 'Water Usage',
    '号的数据是：': ' day data: ',
    '用水': 'Water Usage',
  },
  // 添加月度用水图表的英文翻译
  'homeMonth': {
    'month': 'Month',
    'waterUsage': 'Water Usage',
    'monthlyData': 'Monthly data is',
    '月的数据是': 'Monthly data is',
    '用水': 'Water Usage',
  },
  // 财务报表--充值记录和账单流水的查询
  'details': {
    'search': 'Search',
    'datePicker': {
      'rangeSeparator': 'to',
      'startPlaceholder': 'Start Date',
      'endPlaceholder': 'End Date'
    },
    'community': 'Community:',
    'selectCommunity': 'Select Community',
    'building': 'Building:',
    'selectBuilding': 'Select Building',
    'unit': 'Unit:',
    'selectUnit': 'Select Unit',
    'room': 'Room:',
    'selectRoom': 'Select Room',
    'search_button': 'Search',
    'reset': 'Reset',
    '请输入关键字': 'Search',
    '小区': 'Community:',
    '请选择小区': 'Select Community',
    '楼栋': 'Building:',
    '请选择楼栋': 'Select Building',
    '单元': 'Unit:',
    '请选择单元': 'Select Unit',
    '房间': 'Room:',
    '请选择房间': 'Select Room',
    '查 询': 'Search',
    '重 置': 'Reset',
  }
}
